function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.00361 14C10.8303 14 14 10.8303 14 6.99639C14 3.16968 10.8231 0 6.99639 0C3.16968 0 0 3.16968 0 6.99639C0 10.8303 3.1769 14 7.00361 14ZM3.47292 7.77617C3.19134 7.77617 2.97473 7.55957 2.97473 7.27076C2.97473 6.99639 3.19134 6.77978 3.47292 6.77978H6.4982V2.7148C6.4982 2.44043 6.7148 2.21661 6.99639 2.21661C7.27798 2.21661 7.49459 2.44043 7.49459 2.7148V7.27076C7.49459 7.55957 7.27798 7.77617 6.99639 7.77617H3.47292Z",
  fill: "#878793"
});

function SvgIconClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.0503d4a3.svg";
export { ForwardRef as ReactComponent };